(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-hero-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var d = root.dataset;
    var lossPct = parseFloat(d.lossPct) || 0;
    var timePct = parseFloat(d.timePct) || 0;
    var rate = parseFloat(d.rate) || 0;
    var weeks = parseFloat(d.weeks) || 46;

    var fmt;
    try {
      fmt = new Intl.NumberFormat(d.locale || 'en', { style: 'currency', currency: d.currency || 'EUR', maximumFractionDigits: 0 });
    } catch (e) {
      fmt = { format: function (n) { return '€' + Math.round(n); } };
    }
    function money(n) { return fmt.format(n); }

    // round the headline like a person would
    function roughly(n) {
      var step = n < 1000 ? 50 : n < 10000 ? 100 : 500;
      return Math.round(n / step) * step;
    }

    function field(key) {
      return {
        n: root.querySelector('[data-roi-num="' + key + '"]'),
        r: root.querySelector('[data-roi-range="' + key + '"]')
      };
    }
    var fields = { lost: field('lost'), value: field('value'), hours: field('hours') };

    function val(key) {
      var v = parseFloat(fields[key].n.value);
      return isNaN(v) || v < 0 ? 0 : v;
    }
    function out(key, text) {
      var el = root.querySelector('[data-roi-out="' + key + '"]');
      if (el) el.textContent = text;
    }

    function calc() {
      var lost = val('lost'), value = val('value'), hours = val('hours');
      var lossSave = lost * value * lossPct / 100;
      var timeSave = hours * weeks * timePct / 100 * rate;
      var total = lossSave + timeSave;

      out('total', money(roughly(total)));
    }

    Object.keys(fields).forEach(function (key) {
      var f = fields[key];
      if (!f.n || !f.r) return;
      f.r.addEventListener('input', function () { f.n.value = f.r.value; calc(); });
      f.n.addEventListener('input', function () { f.r.value = f.n.value; calc(); });
      f.n.addEventListener('change', function () {
        var v = parseFloat(f.n.value);
        var min = parseFloat(f.n.min), max = parseFloat(f.n.max);
        if (isNaN(v)) v = min;
        f.n.value = Math.min(max, Math.max(min, v));
        f.r.value = f.n.value;
        calc();
      });
    });

    calc();
  }

  function initAll() { document.querySelectorAll('[data-gt-roi]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
